export default {
  id: 61,
  title: 'Target #61 - ImprovMX',
  url: 'https://cssbattle.dev/play/61',
  colors: ['#191919', '#5DBCF9'],
  solution:
    '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#191919}a{position:fixed}a[a],a[b],a[c],a[d]{border:10px solid #5DBCF9}a[a]{top:66;left:175;width:30;height:20}a[b]{top:96;left:150;width:80;height:55;border-bottom:0}a[c],a[d]{top:146;border-bottom:0;width:80;height:30}a[c]{left:126;border-right:0;transform:rotate(-30deg)}a[d]{right:126;border-left:0;;transform:rotate(30deg)}a[e],a[f],a[g]{background:#5DBCF9}a[e]{top:130;left:195;width:10;height:75}a[f],a[g]{height:10}a[f]{top:204;left:100;width:200;box-shadow:0 -10px #191919}a[g]{top:224;left:145;width:110}</style>',
}
